import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';

@Component({
  selector: 'page-select-event',
  templateUrl: 'select-event.html',
})
export class SelectEvent {

  eventList: any;
  client: any;

  constructor(public navCtrl: NavController, public params: NavParams, public view: ViewController) {
    this.eventList = this.params.get('eventList');
    this.client = this.params.get('client');
  }

  send(selected = false) {
    this.view.dismiss({selected: selected});
  }
}
// end file



// WEBPACK FOOTER //
// ./src/pages/select-event/select-event.ts